<script setup>
import axios from "axios";
import { ref, reactive, onMounted } from "vue";
import {
  queryLocationTree,
  deleteLocationById,
  queryLocationById,
} from "@/api/location";
import { queryDictData } from "@/api/common";
import Adjust from "./adjust.vue";
import { ElMessage, ElMessageBox } from "element-plus";

// 页面title
const title = ref("所属位置");

// 区域树
const locationTree = ref([]);

// 树遮罩
const treeLoading = ref(false);

// 编辑弹窗ref
const adjustRef = ref(null);

// 类型列表
const areaTypeList = ref([]);

// 树props
const defaultProps = reactive({
  label: "name",
});

// 描述列表对象
const descriptionData = reactive({
  name: null,
  areaType: null,
  remark: null,
  logo: null,
});

// 区域图片
const areaImageUrl = ref("");

// 树点击操作
const handleNodeClick = (data) => {
  queryLocationById(data.id).then((res) => {
    if (JSON.stringify(res.data) !== "{}") {
      for (const key in descriptionData) {
        descriptionData[key] = res.data[key];
      }
      if (!descriptionData.logo) return (areaImageUrl.value = "");
      filePreview(descriptionData.logo);
    }
  });
};

// 获取树
const getLocations = () => {
  treeLoading.value = true;
  queryLocationTree()
    .then((res) => {
      locationTree.value = res.data;
    })
    .finally(() => {
      if (locationTree.value.length == 0) {
        locationTree.value.push({
          areaType: 1,
          name: "根节点",
          parentId: null,
          ancestors: null,
          id: 0,
          remark: "新增子节点后消失",
        });
      }

      for (const key in descriptionData) {
        descriptionData[key] = locationTree.value[0][key];
      }
      treeLoading.value = false;
      if (!descriptionData.logo) return (areaImageUrl.value = "");
      filePreview(descriptionData.logo);
    });
};

// 获取字典数据
const getLocationType = () => {
  queryDictData("sys_location_type").then((res) => {
    areaTypeList.value = res.data || [];
  });
};

// 通过字典类型获取字典数据
const getDicNameByValue = (key) => {
  let name;
  for (let i = 0; i < areaTypeList.value.length; i++) {
    if (areaTypeList.value[i].dictValue == key) {
      name = areaTypeList.value[i].dictLabel;
      break;
    }
  }
  return name;
};

// 点击新增或者编辑
const handleLocationAdjust = (node, data, type) => {
  adjustRef.value?.handleDialogOpen(data, type);
};

// 点击删除
const handleLocationDelete = (row) => {
  ElMessageBox.confirm("确定删除区域位置?", "警告", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "error",
  })
    .then(() => {
      deleteLocationById(row.id).then((res) => {
        if (res.code == "2000") {
          ElMessage.success("操作成功");
          getLocations();
        }
      });
    })
    .catch(() => {});
};

// 文件预览
const filePreview = (reduceUrl) => {
  axios
    .post("/api/operate/file/preview", { reduceUrl }, { responseType: "blob" })
    .then((res) => {
      areaImageUrl.value = window.URL.createObjectURL(res.data);
    });
};

onMounted(async () => {
  getLocations();
  getLocationType();
});
</script>

<template>
  <zh-table-page v-bind="{ title }">
    <template #header-btn> </template>
    <template #search></template>
    <template #left>
      <el-tree
        ref="treeRef"
        :data="locationTree"
        node-key="id"
        default-expand-all
        :props="defaultProps"
        :expand-on-click-node="false"
        :highlight-current="true"
        @node-click="handleNodeClick"
        :current-node-key="locationTree[0]?.id"
      >
        <template #default="{ node, data }">
          <span class="custom-tree-node">
            <span>{{ node.label }}</span>
            <span class="btn">
              <el-icon @click.stop="handleLocationAdjust(node, data, 'add')"
                ><CirclePlusFilled color="#409EFF"
              /></el-icon>
              <el-icon @click.stop="handleLocationAdjust(node, data, 'edit')"
                ><EditPen color="#67C23A"
              /></el-icon>
              <el-icon @click.stop="handleLocationDelete(data)"
                ><DeleteFilled color="#F56C6C"
              /></el-icon>
            </span>
          </span>
        </template>
      </el-tree>
    </template>
    <template #table>
      <el-form>
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item>
              <el-image
                style="width: 178px; height: 178px"
                :src="areaImageUrl"
              />
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item label="区域位置名称:">{{
                  descriptionData.name
                }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="类型:">{{
                  getDicNameByValue(descriptionData.areaType)
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col>
                <el-form-item label="备注:">{{
                  descriptionData.remark
                }}</el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </template>
  </zh-table-page>

  <!-- 编辑弹窗 -->
  <adjust ref="adjustRef" @afterSave="getLocations" />
</template>

<style lang="scss" scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;

  .btn {
    width: 60px;
    display: flex;
    justify-content: space-between;
  }
}
</style>
